import { Route, Routes } from "react-router";

import { UnsavedChangesScope } from "../catalog/unsaved";
import { ImportListPage } from "./pages/ImportListPage";
import { ImportWizardPage } from "./pages/ImportWizardPage";
import { ImportReviewPage } from "./review/ImportReviewPage";

/**
 * The import routes, mounted at `/imports/*`:
 *   /imports                  the list of drafts and jobs     /imports/new     a new import
 *   /imports/:jobId           open a saved draft (the mapping step, with the saved decisions)
 *   /imports/:jobId/review    review, approval and progress of a submitted import (CHT-708)
 */
export function ImportRoutes() {
  return (
    <UnsavedChangesScope>
      <Routes>
        <Route index element={<ImportListPage />} />
        <Route path="new" element={<ImportWizardPage />} />
        <Route path=":jobId" element={<ImportWizardPage />} />
        <Route path=":jobId/review" element={<ImportReviewPage />} />
      </Routes>
    </UnsavedChangesScope>
  );
}
